function findTemplateList(source) {
  if (Array.isArray(source)) return source;
  if (!source || typeof source !== 'object') return [];

  const candidateKeys = [
    'templates',
    'template_list',
    'template_options',
    'list',
    'results',
    'items',
    'values',
  ];
  for (const key of candidateKeys) {
    if (Array.isArray(source[key]) && source[key].length) return source[key];
  }

  const nestedData = findTemplateList(source.data);
  if (nestedData.length) return nestedData;
  const nestedResult = findTemplateList(source.result);
  if (nestedResult.length) return nestedResult;
  return [];
}

export function normalizeWhatsappTemplateOptions(source, allLabel) {
  const templates = findTemplateList(source);
  const options = templates.map((item) => {
    if (typeof item === 'string' || typeof item === 'number') {
      const value = String(item);
      return { id: value, label: value };
    }
    const id = item?.id
      ?? item?.template_id
      ?? item?.md_id
      ?? item?.wa_Id
      ?? item?.wa_id
      ?? item?.value
      ?? item?.template_uuid;
    const label = item?.label
      || item?.template_name
      || item?.template_label
      || item?.display_name
      || item?.name
      || item?.template;
    if (id == null || label == null || String(label).trim() === '') return null;
    return { id: String(id), label: String(label) };
  }).filter(Boolean);

  return [{ id: '', label: allLabel }, ...options];
}
